module.exports = __webpack_public_path__ + "media/Audio17_f.f2a4700b.wav";